export const SAVE_APPLICATION_DATA = "SAVE_APPLICATION_DATA";